module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Chair1-68528880f55fe53553952e88bd9ae02c.svg";